import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { mainRequest } from "../api";
import { METHOD } from "../api/constants";

function useFetch(urlPath) {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(false);
  const langState = useSelector((state) => state.language.lang);
  const searchState = useSelector((state) => state.filter.filterByName);

  const fetchData = useCallback(async () => {
    const { get } = METHOD;
    setLoading(true);
    setError(false);
    try {
      const response = await mainRequest(urlPath, { lang: langState }, get);
      const data = await response.data.data;

      if (data) {
        setResults(data);
        setLoading(false);
      }
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  }, [urlPath, langState]);

  useEffect(() => {
    fetchData();
  }, [fetchData,searchState]);

  return [error, loading, results];
}

export default useFetch;
